import { TRANSLATION_KEYS } from "./TranslationKeys";

import type { ToastProps } from "components/toasts/MessageToast";

export const TOASTS_IDS = {
  cashManagementAccountUpdateSuccess: "cash-management-account-update-success",
  createProviderConfigSuccess: "create-provider-config-success",
  updateProviderConfigSuccess: "update-provider-config-success",
  isxPayoutConfigurationUpdateSuccess:
    "connect-isx-payout-configuration-update-success",
  isxProviderNotFound: "isx-provider-not-found",
  settlementBatchesTriggerSuccess: "settlement-batches-trigger-success",
  settleAccountSuccess: "settle-account-success",
  accountCreateSuccessToast: "account-create-success-toast",
  reportNotificationsSettingsUpdateSuccess:
    "report-notifications-settings-update-success",
  reportNotificationsSettingsTestSuccess:
    "report-notifications-settings-test-success",
  creditNotificationsSettingsTestSuccess:
    "credit-notifications-settings-test-success",
  creditNotificationsSettingsUpdateSuccess:
    "credit-notifications-settings-update-success",
  payoutNotificationsSettingsUpdateSuccess:
    "payout-notifications-settings-update-success",
  reserveConfigurationUpdateSuccess: "reserve-configuration-update-success",
  scheduleConfigurationUpdateSuccess: "schedule-configuration-update-success",
  convertFxRequestSuccess: "schedule-configuration-update-success",
  settlementReportDownloadError: "settlement-report-download-error",
} as const;

export const TOASTS = {
  validationError: (message: string): ToastProps => ({
    bodyContent: message,
    variant: "failure",
  }),
  isxPayoutConfigurationUpdateSuccess: {
    bodyContent: TRANSLATION_KEYS.isxPayoutConfigurationUpdated,
    variant: "success",
    config: {
      toastId: TOASTS_IDS.isxPayoutConfigurationUpdateSuccess,
    },
  },
  settlementReportDownloadError: (message: string): ToastProps => ({
    bodyContent: message,
    variant: "failure",
    config: {
      toastId: TOASTS_IDS.settlementReportDownloadError,
    },
  }),
  isxProviderNotFound: {
    bodyContent: TRANSLATION_KEYS.isxProviderNotFound,
    variant: "failure",
    config: {
      toastId: TOASTS_IDS.isxProviderNotFound,
    },
  },
  cashManagementAccountUpdateSuccess: {
    bodyContent: TRANSLATION_KEYS.cashManagementAccountHasBeenUpdated,
    variant: "success",
    config: {
      toastId: TOASTS_IDS.cashManagementAccountUpdateSuccess,
    },
  },
  reportNotificationsSettingsUpdateSuccess: {
    bodyContent:
      TRANSLATION_KEYS.reportNotificationsSettingsUpdatedSuccessfully,
    variant: "success",
    config: {
      toastId: TOASTS_IDS.reportNotificationsSettingsUpdateSuccess,
    },
  },
  reportNotificationsSettingsTestSuccess: (message: string): ToastProps => ({
    variant: "success",
    bodyContent: message,
    config: {
      toastId: TOASTS_IDS.reportNotificationsSettingsTestSuccess,
    },
  }),
  payoutNotificationsSettingsUpdateSuccess: {
    bodyContent:
      TRANSLATION_KEYS.payoutNotificationsSettingsUpdatedSuccessfully,
    variant: "success",
    config: {
      toastId: TOASTS_IDS.payoutNotificationsSettingsUpdateSuccess,
    },
  },
  settlementBatchesTriggerSuccess: (message: string): ToastProps => ({
    bodyContent: message,
    variant: "success",
    config: {
      toastId: TOASTS_IDS.settlementBatchesTriggerSuccess,
    },
  }),
  createProviderConfigSuccess: {
    bodyContent: TRANSLATION_KEYS.providerConfigUpdated,
    variant: "success",
    config: {
      toastId: TOASTS_IDS.createProviderConfigSuccess,
    },
  },
  updateProviderConfigSuccess: {
    bodyContent: TRANSLATION_KEYS.providerConfigUpdated,
    variant: "success",
    config: {
      toastId: TOASTS_IDS.createProviderConfigSuccess,
    },
  },
  accountCreateSuccess: {
    variant: "success",
    bodyContent: TRANSLATION_KEYS.virtualAccountCreatedSuccessfully,
    config: {
      toastId: TOASTS_IDS.accountCreateSuccessToast,
    },
  },
  creditNotificationsSettingsUpdateSuccess: {
    bodyContent:
      TRANSLATION_KEYS.creditNotificationsSettingsUpdatedSuccessfully,
    variant: "success",
    config: {
      toastId: TOASTS_IDS.creditNotificationsSettingsUpdateSuccess,
    },
  },
  creditNotificationsSettingsTestSuccess: (message: string): ToastProps => ({
    variant: "success",
    bodyContent: message,
    config: {
      toastId: TOASTS_IDS.creditNotificationsSettingsTestSuccess,
    },
  }),
  settleAccountSuccess: {
    bodyContent: TRANSLATION_KEYS.weHaveSettledYourAccount,
    variant: "success",
    config: {
      toastId: TOASTS_IDS.settleAccountSuccess,
    },
  },
  reserveConfigurationUpdateSuccess: {
    bodyContent: TRANSLATION_KEYS.reserveConfigurationUpdatedSuccessfully,
    variant: "success",
    config: {
      toastId: TOASTS_IDS.reserveConfigurationUpdateSuccess,
    },
  },
  scheduleConfigurationUpdateSuccess: {
    bodyContent:
      TRANSLATION_KEYS.settlementScheduleConfigurationUpdatedSuccessfully,
    variant: "success",
    config: {
      toastId: TOASTS_IDS.scheduleConfigurationUpdateSuccess,
    },
  },
  convertFXSuccess: {
    bodyContent: TRANSLATION_KEYS.fXConversionRequestSentSuccessfully,
    variant: "success",
    config: {
      toastId: TOASTS_IDS.scheduleConfigurationUpdateSuccess,
    },
  },
} as const;

export const PAYOUT_NOTIFICATION_TOASTS = {
  createdNotifications: {
    variant: "success",
    bodyContent: TRANSLATION_KEYS.payoutNotificationsSettingsHaveBeenCreated,
  },
  updatedNotifications: {
    variant: "success",
    bodyContent: TRANSLATION_KEYS.payoutNotificationsSettingsHaveBeenUpdated,
  },
  testSuccess: (message: string): ToastProps => ({
    variant: "success",
    bodyContent: message,
  }),
} as const;
